<template>
  <v-app id="inspire" class="bgauth">
    <v-main>
      <v-fade-transition hide-on-leave="">
        <div class="auth-wrapper d-flex justify-center align-center">
          <div class="auth-container px-10 py-10 rounded-lg">
            <router-view :key="$route.path" />
          </div>
        </div>
      </v-fade-transition>
      <overlay-loading/>
    </v-main>
  </v-app>
</template>

<script>

import OverlayLoading from '../components/OverlayLoading'
import { get } from 'vuex-pathify'

export default {
  name: 'AuthLayout',
  components: { OverlayLoading },
  data: () => ({
  }),
  computed: {
    loggedInStatus: get('auth/loggedInStatus')
  },
  created() {
    if (this.loggedInStatus) {
      this.$router.push({ replace: true, name: 'dashboard' })
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-wrapper {
    min-height: 100vh;
}
.auth-container {
    width: 100%;
    max-width: 450px;
}

.theme--light {
  .auth-container {
    background-color: #fafafa;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border: 1px solid #ccc;
  }
  &.bgauth {
    background: url('/bgauth.jpg') no-repeat center center fixed !important;
    background-size: cover;
  }
}
.theme--dark {
  .auth-container {
    background-color: #01153a;
    box-shadow: 0 0 10px rgba(0, 27, 85, 0.1);
    border: 1px solid #333;
  }
  &.bgauth {
    background: url('/bgauthdark.jpg') no-repeat center center fixed !important;
    background-size: cover;
  }
}
</style>
